import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Items from './Items';
import { backdropClasses, TextField, useStepContext } from '@mui/material';
import axios from 'axios'
import PackageCards from './PackageCards';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;



  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


export default function TableTabs(props) {

  const [value, setValue] = React.useState(0);
  const [change, setChange] = useState(0)
  const [categories, setCategories] = useState([])

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const [allItems, setAllItems] = useState([])
  const [packages, setPackages] = useState([])

  const [triggerItem, setTriggerItem] = useState('')
  useEffect(() => {

    axios.get("https://serveravotasautofleet.ccsoftwares.com/Category/getallcategoryBilling").then(res => {
      setCategories(res.data)
    }).catch(e => {
      ////console.log(e)
    })

    axios.get("https://serveravotasautofleet.ccsoftwares.com/Item/getItemDetailsforBilling").then(res => {
      setAllItems(res.data)
    }).catch(e => {
      ////console.log(e)
    })

    axios.get("https://serveravotasautofleet.ccsoftwares.com/Packages/getPackagesForBilling").then(res => {
      setPackages(res.data || [])
    }).catch(() => {
      setPackages([])
    })


  }, [triggerItem])


  const [search, setSearch] = useState('')
  const tabs = props.showAllItemsTab
    ? [{ CategoryID: 'all-items', CategoryName: 'All Items' }, ...categories]
    : [...categories];

  const getFilteredItems = (item, tab) => {
    const searchText = (search || '').toLowerCase();
    const itemName = (item?.ItemName || '').toLowerCase();
    const categoryId = Number(tab?.CategoryID);
    const itemCategoryId = Number(item?.ItemCategoryID);

    if (tab?.CategoryID === 'all-items') {
      return searchText === '' || itemName.includes(searchText);
    }

    if (Number(tab?.CategoryID) === 1000 && tab?.CategoryName === 'Favourite') {
      if (Number(item?.isfavourite) !== 1) return false;
      return searchText === '' || itemName.includes(searchText);
    }

    if (searchText === '') {
      return itemCategoryId === categoryId;
    }

    return itemName.includes(searchText) && itemCategoryId === categoryId;
  };

  return (
    <Box sx={{ width: 'auto' }} style={{ backgroundColor: '#ffffffff',height: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} style={{backgroundColor: '#ffffffff'}}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable">
          {tabs.map((e, i) => (
            <Tab key={e.CategoryID ?? i} label={e.CategoryName} {...a11yProps(i)} style={{ fontWeight: '900' }} />
          ))}

        </Tabs>
      </Box>

      {tabs.map((e, i) => (
        <CustomTabPanel key={e.CategoryID ?? i} value={value} index={i}>

          <TextField id="outlined-basic" label="Search..." variant="outlined" onChange={(e) => {
            setSearch(e.target.value);
          }} value={search} style={{ width: '100%' }} placeholder='Search...' />

          <hr></hr>
          <div style={{ overflow: 'scroll', overflowX: 'hidden', height: '75vh'}}>

            {e.CategoryID === 'packages' ? (
              <PackageCards
                packages={packages}
                addToBill={props.bill}
                search={search}
              />
            ) : (
              <Items
                items={allItems.filter((element) => getFilteredItems(element, e))}
                addToBill={props.bill}
                changeFunction={setAllItems}
                focus={props.focus}
                trig={(e) => { setTriggerItem(e) }}
              />
            )}

          </div>
        </CustomTabPanel>
      ))}

    </Box>
  );
}
